var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('img',{staticClass:"vessel-image",attrs:{"id":"image-loading","src":_vm.image,"text":_vm.avatarText}})}
var staticRenderFns = []

export { render, staticRenderFns }